import React, { useState } from 'react';
import { Server, Lock, CheckCircle } from 'lucide-react';
import api from '../services/api';
import { toast } from 'react-toastify';

export default function SetupPage() {
  const [form, setForm] = useState({ server: '', name: '', user: '', password: '', port: '1433', encrypt: false });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/settings/setup', { ...form, port: parseInt(form.port) });
      if (res.data.success) {
        toast.success('Veritabanı bağlantısı başarılı! Yönlendiriliyorsunuz...');
        setTimeout(() => window.location.href = '/login', 1500);
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Bağlantı hatası');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="DSY" className="h-20 mx-auto mb-6 drop-shadow-2xl" />
          <h1 className="text-3xl font-bold text-white">Sistem Kurulumu</h1>
          <p className="text-blue-200 mt-2">Veritabanı bağlantı bilgilerini girin</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 space-y-5 border border-white/20">
          <div>
            <label className="block text-sm font-medium text-blue-100 mb-1.5">Sunucu Adresi</label>
            <div className="relative">
              <Server size={18} className="absolute left-3 top-3 text-blue-300" />
              <input type="text" value={form.server} onChange={e => setForm({...form, server: e.target.value})} required
                className="w-full pl-10 pr-4 py-2.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="localhost veya IP adresi" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-blue-100 mb-1.5">Veritabanı Adı</label>
            <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required
              className="w-full px-4 py-2.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="TicketDB" />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-blue-100 mb-1.5">Kullanıcı Adı</label>
              <input type="text" value={form.user} onChange={e => setForm({...form, user: e.target.value})}
                className="w-full px-4 py-2.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="sa" />
            </div>
            <div>
              <label className="block text-sm font-medium text-blue-100 mb-1.5">Port</label>
              <input type="number" value={form.port} onChange={e => setForm({...form, port: e.target.value})}
                className="w-full px-4 py-2.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-blue-100 mb-1.5">Şifre</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-3 text-blue-300" />
              <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
                className="w-full pl-10 pr-4 py-2.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="••••••••" />
            </div>
          </div>

          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={form.encrypt} onChange={e => setForm({...form, encrypt: e.target.checked})}
              className="w-4 h-4 rounded border-white/30 bg-white/10 text-blue-500 focus:ring-blue-500" />
            <span className="text-sm text-blue-100">Şifreli bağlantı (Encrypt)</span>
          </label>

          <button type="submit" disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-600/30 disabled:opacity-50 flex items-center justify-center gap-2">
            {loading ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" /> : <><CheckCircle size={20} /> Bağlantıyı Test Et ve Kur</>}
          </button>
        </form>
      </div>
    </div>
  );
}
